module.exports = __webpack_public_path__ + "static/media/globalgreen.8e296e02.md";